import { Maybe } from '@csp/csp-common-model';
import { PatientWebConfig } from '../model/PatientWebConfig';

const singleton: { config: PatientWebConfig } = {
  config: PatientWebConfig.empty(),
};

const getBaseUrl = (): string => singleton.config.baseUrl;

const set = (config: Maybe<PatientWebConfig>): void => {
  if (config) {
    singleton.config = config;
  }
};

const get = (): PatientWebConfig => singleton.config;

export const PatientWebConfigService = {
  getBaseUrl,
  set,
  get,
};
